function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#68D4F8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M36 17s7 5 15 5v11c0 16-13 22-15 22s-15-6-15-22V22c8 0 15-5 15-5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CEF2FF",
  d: "M36 17s7 5 15 5v11c0 16-13 22-15 22V17z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#68D4F8",
  d: "M35.16 37.55L32.5 35.5c-.84-.72-1.95-.05-1.35 1.03l2.8 3.91c.37.49 1.2.97 2.05 0l6.7-9.09c.83-.96-.25-1.8-.97-1.08l-6.57 7.28z"
});

function SvgCompliance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MiA3MiI+PGNpcmNsZSBjeD0iMzYiIGN5PSIzNiIgcj0iMzYiIGZpbGw9IiM2OEQ0RjgiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMzYgMTdzNyA1IDE1IDV2MTFjMCAxNi0xMyAyMi0xNSAyMnMtMTUtNi0xNS0yMlYyMmM4IDAgMTUtNSAxNS01eiIvPjxwYXRoIGZpbGw9IiNDRUYyRkYiIGQ9Ik0zNiAxN3M3IDUgMTUgNXYxMWMwIDE2LTEzIDIyLTE1IDIyVjE3eiIvPjxwYXRoIGZpbGw9IiM2OEQ0RjgiIGQ9Ik0zNS4xNiAzNy41NUwzMi41IDM1LjVjLS44NC0uNzItMS45NS0uMDUtMS4zNSAxLjAzbDIuOCAzLjkxYy4zNy40OSAxLjIuOTcgMi4wNSAwbDYuNy05LjA5Yy44My0uOTYtLjI1LTEuOC0uOTctMS4wOGwtNi41NyA3LjI4eiIvPjwvc3ZnPgo=";
export { SvgCompliance as ReactComponent };